import { OrderError } from "common/clients/orders/DeliverrOrder/OrderError";
import { OrderStatus } from "common/clients/orders/DeliverrOrder/OrderStatus";

export const isBadAddress = (order) => order.error === OrderError.BAD_ADDRESS && order.status === OrderStatus.ERROR;
